import { render, staticRenderFns } from "./Setup.vue?vue&type=template&id=5ea4bfec&scoped=true&"
import script from "./Setup.vue?vue&type=script&lang=ts&"
export * from "./Setup.vue?vue&type=script&lang=ts&"
import style0 from "./Setup.vue?vue&type=style&index=0&id=5ea4bfec&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ea4bfec",
  null
  
)

export default component.exports